export const BMP_TAX_TOOL_DOMAIN = 'app/modules/Contents/BMP_TAX_TOOL_DOMAIN';
export const TOOLS_DOMAIN = 'app/modules/Contents/TOOLS_DOMAIN';
export const REQUEST_BMP_TAX_CALCULATION = 'app/modules/Contents/REQUEST_BMP_TAX_CALCULATION';
export const GENERATE_OPTIONS = 'app/modules/Contents/GENERATE_OPTIONS';
export const PRICE_TYPES = {
  BTW: 'BTW',
  MARGE: 'MARGE',
};

export const REQUEST_DWH_STATUS = 'app/modules/Contents/REQUEST_DWH_STATUS';
